"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BandCode = exports.ThemeBandsSequence = exports.ThemeBands = exports.BandsKeys = exports.Bands = void 0;
exports.getAssessmentBands = getAssessmentBands;
exports.getAssessmentBandCodeByPercentage = getAssessmentBandCodeByPercentage;
exports.getAssessmentBandsFrom = getAssessmentBandsFrom;
var Bands;
(function (Bands) {
    Bands["None"] = "none";
    Bands["Empty"] = "empty";
    Bands["NotProficient"] = "not-proficient";
    Bands["PartiallyProficient"] = "partially-proficient";
    Bands["Proficient"] = "proficient";
    Bands["HighlyProficient"] = "highly-proficient";
})(Bands || (exports.Bands = Bands = {}));
var BandsKeys;
(function (BandsKeys) {
    BandsKeys["NotYet"] = "Not Yet Proficient";
    BandsKeys["Partial"] = "Partially Proficient";
    BandsKeys["Proficient"] = "Proficient";
    BandsKeys["Highly"] = "Highly Proficient";
})(BandsKeys || (exports.BandsKeys = BandsKeys = {}));
exports.ThemeBands = (_a = {},
    _a[Bands.NotProficient] = 'notYet',
    _a[Bands.PartiallyProficient] = 'partial',
    _a[Bands.Proficient] = 'proficient',
    _a[Bands.HighlyProficient] = 'highlyProficient',
    _a);
exports.ThemeBandsSequence = (_b = {},
    _b[Bands.None] = 1,
    _b[Bands.Empty] = 2,
    _b[Bands.NotProficient] = 3,
    _b[Bands.PartiallyProficient] = 4,
    _b[Bands.Proficient] = 5,
    _b[Bands.HighlyProficient] = 6,
    _b);
var BandCode;
(function (BandCode) {
    BandCode["not-proficient"] = "Not Yet Proficient";
    BandCode["partially-proficient"] = "Partially Proficient";
    BandCode["proficient"] = "Proficient";
    BandCode["highly-proficient"] = "Highly Proficient";
})(BandCode || (exports.BandCode = BandCode = {}));
function getAssessmentBands() {
    return [
        Bands.None,
        Bands.Empty,
        Bands.NotProficient,
        Bands.PartiallyProficient,
        Bands.Proficient,
        Bands.HighlyProficient,
    ];
}
function getAssessmentBandCodeByPercentage(percentage) {
    return percentage > 89.99
        ? BandCode[Bands.HighlyProficient]
        : percentage > 59.99
            ? BandCode[Bands.Proficient]
            : percentage > 39.99
                ? BandCode[Bands.PartiallyProficient]
                : BandCode[Bands.NotProficient];
}
function getAssessmentBandsFrom(value) {
    return getAssessmentBands().find(function (type) { return type === value; });
}
